import { MessageCircle, ShieldCheck } from "lucide-react";

import { Button } from "@/components/ui/button";
import { openMinSupportChat } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { MIN_LINKING_TRUST_CHECKPOINT_CONTENT } from "@/lib/trust-content";

export default function LinkingTrustCheckpoint({ disabled = false, onContinue }) {
  const { tx } = useI18n();

  return (
    <div className="flex w-full flex-col items-center gap-4" data-testid="linking-trust-checkpoint">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
        <ShieldCheck className="h-7 w-7" />
      </div>
      <div className="w-full space-y-3 text-left">
        <p className="text-sm leading-relaxed text-muted-foreground">
          {tx(MIN_LINKING_TRUST_CHECKPOINT_CONTENT.body)}
        </p>
        <div className="grid gap-2">
          {MIN_LINKING_TRUST_CHECKPOINT_CONTENT.points.map((point) => (
            <div
              key={point.text}
              className="rounded-2xl border border-border/70 bg-muted/40 px-3 py-3 text-sm leading-relaxed text-muted-foreground"
            >
              {tx(point.text)}
            </div>
          ))}
        </div>
      </div>
      <Button
        className="h-12 w-full rounded-xl"
        onClick={onContinue}
        disabled={disabled}
        data-testid="linking-trust-continue"
      >
        {tx(MIN_LINKING_TRUST_CHECKPOINT_CONTENT.ctaLabel)}
      </Button>
      <Button
        type="button"
        variant="ghost"
        className="h-11 w-full rounded-xl gap-2 text-muted-foreground"
        onClick={() => {
          void openMinSupportChat({ sourceStep: "linking_trust_checkpoint" });
        }}
        disabled={disabled}
        data-testid="linking-trust-support"
      >
        <MessageCircle className="h-4 w-4" />
        {tx(MIN_LINKING_TRUST_CHECKPOINT_CONTENT.secondaryCtaLabel)}
      </Button>
    </div>
  );
}
